<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50004 5.33398V8.00065M8.50004 10.6673H8.50671M15.1667 8.00065C15.1667 11.6826 12.1819 14.6673 8.50004 14.6673C4.81814 14.6673 1.83337 11.6826 1.83337 8.00065C1.83337 4.31875 4.81814 1.33398 8.50004 1.33398C12.1819 1.33398 15.1667 4.31875 15.1667 8.00065Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
